<!-- Eng -->
@if (isEng) {
  <div class="common-sub-container">
    <div class="common-container">
      <h1 class="common-sub-block__h1">Support</h1>
      <p class="common-sub-block__descr common-sub-block__descr--height">Technical support 24/7</p>
    </div>
  </div>
}

<!-- Ru -->
@if (!isEng) {
  <div class="common-sub-container">
    <div class="common-container">
      <h1 class="common-sub-block__h1">Техподдержка</h1>
      <p class="common-sub-block__descr common-sub-block__descr--height">Техподержка 24/7</p>
    </div>
  </div>
}
